import { apiConfig } from "./config";

export const AuthApi = {
  sendOtp: async (phoneNumber: string) => {
    await apiConfig.post("/api/authenticate/chef", {
      phoneNumber: phoneNumber,
    });
  },
  loginWithOtp: async (phoneNumber: string, code: string) => {
    await apiConfig.post("/api/authenticate/login-otp", {
      phoneNumber: phoneNumber,
      code: code,
    });
  },
  logout: async () => {
    await apiConfig.post("/api/authenticate/logout", {});
  },
  profile: async () => {
    const response = await apiConfig.get("/api/front/chef/profile");
    return response;
  },
  avgScore: async () => {
    const response = await apiConfig.get("/api/front/chef/average-score");
    return response;
  },
  registerFCMToken: async (userId: string, fcmToken: string) => {
    try {
      const response = await apiConfig.post(`/api/app/fcm/${userId}/fcm-tokens`, {
        fcmToken: fcmToken,
      });
      return response;
    } catch (error) {
      console.error("Error registering FCM token:", error);
      throw error;
    }
  },
};
